module.exports = __webpack_public_path__ + "assets/media/euro-prize.6c09d078.svg";